import { Injectable, ElementRef } from '@angular/core';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import * as moment from "moment";

export interface Toast {
  message: string;
  type: string;
  timeout: number;
}

@Injectable()
export class CommonService {
  toast$: Subject<Toast> = new BehaviorSubject<Toast>(null);
  constructor() { }

  //backend success alert message variables
  private status_type_source: Subject <any> = new BehaviorSubject<any>(null);
  private status_msg_source: Subject <any> = new BehaviorSubject<any>(null);
  private status_module_source: Subject <any> = new BehaviorSubject<any>(null);
  status_type$ = this.status_type_source.asObservable();
  status_msg$ = this.status_msg_source.asObservable();
  status_module$ = this.status_module_source.asObservable();

  //backend success alert massages variables
  setStatusType(type_stat){
    this.status_type_source.next(type_stat);
  }

  setstatusMsg(msg){
    this.status_msg_source.next(msg);
  }

  setstatusModule(msg){
    this.status_module_source.next(msg);
  }

  //end of backend success alert

  /* start @Created by FaisalK @Date  2019-04-25 @Desc alert*/
  private alertSource: Subject <String> = new BehaviorSubject <String> ("");
  alert(message: String) {
    this.alertSource.next(message);
  }
  alert$ = this.alertSource.asObservable();
  /* end @Desc alert*/

  /* start @Created by FaisalK @Date  2019-04-25 @Desc loader*/

  private showLoaderSource: Subject <any> = new BehaviorSubject <any> (null);
  showLoader(data:any=null){
    this.showLoaderSource.next({...data,flag:true});
  }
  showLoader$ = this.showLoaderSource.asObservable();

  private hideLoaderSource: Subject <any> = new BehaviorSubject <any> (null);
  hideLoader(data:any=null){
    this.hideLoaderSource.next({...data,flag:true});
  }
  hideLoader$ = this.hideLoaderSource.asObservable();

  date(...args){
    switch(args.length){
      case 1:
        if(typeof(args[0])==="string") return moment(args[0], args[0].includes("/")?"MM/DD/YYYY":"YYYY-MM-DD").toDate();
        else return moment(args[0]).toDate();
      case 2:return moment().year(args[0]).month(args[1]).toDate();
      case 3:return moment().year(args[0]).month(args[1]).date(args[2]).toDate();
    }
    return moment().toDate();
  }

  datediff(date1,date2){
    let firstdate = moment(date1);
    let seconddate = moment(date2);
    return Math.abs(firstdate.diff(seconddate, 'days'));
  }

  convertDateTimeToUTCFormat(str) {
    return new Date(moment(str).utc().format('MM/DD/YYYY hh:mm:ss A'));
  }

  convertDateToWidgetFormat(date:string) {
    const formatted = moment(date).format('MM/DD/YYYY h:mm A');
    return formatted;
  }

  /* Focus on Invalid Fields method end */
  scrollToError(el:ElementRef) {
    const invalidElements = el.nativeElement.querySelectorAll('.ng-invalid');
    if (invalidElements.length > 0) {
      window.scrollTo({
        top: document.documentElement.scrollTop+invalidElements[0].getBoundingClientRect().top-110,
        left: 0,
        behavior: 'smooth'
      });
    }
  }
  /* Focus on Invalid Fields method end */

  /* start @Created by FaisalK @Date  2019-04-25 @Desc reload*/
  private askForReloadSource: Subject <any> = new BehaviorSubject <any> (null);
  askForReload(message: any=true) {
    this.askForReloadSource.next(message);
  }
  askForReload$ = this.askForReloadSource.asObservable();
  /* end @Desc reload*/

  toast(message: string, type: 'success'|'error'|'info'|'warning' = 'success', timeout = 3000) {
    this.toast$.next({message, type, timeout});
  }

  getToast(): Observable<Toast> {
    return this.toast$.asObservable();
  }

  formatCalendarDate(dateObj): string {
    const {date} = dateObj;
    const month = parseInt(date.month) >= 10 ? date.month : `0${date.month}`;
    const day = parseInt(date.day) >= 10 ? date.day : `0${date.day}`;
    return `${date.year}-${month}-${day}`;
  }

  momentToHumanDate(date) {
    const formatter = new Intl.DateTimeFormat('en-US', {weekday: 'long', year: 'numeric', month: 'short', day: 'numeric'});
    const formatted = formatter.format(date);
    return formatted;
  }

  formattedDateToObj(dateStr) {
    const [year, month, day] = dateStr.split('-').map(Number);
    const jsdate = new Date(year, month - 1, day); // month is 0-indexed in JS
    return {
      date: {
        year,
        month,
        day
      },
      epoc: jsdate.getTime(),
      formatted: `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${year}`,
      jsdate
    };
  }

  checkPhoneValidation() {
		return (control): { [key: string]: any } => {
      if (!control.value) return null;
      const numericValue: string = control.value ? control.value.replace(/[^\d]/g, '') : '';
      if (numericValue.length && numericValue.length < 7) {
        return {invalidPhone: 'Not enough digits for a phone number.'}
      }
      return null;
    };
  }

  getCurrentUser(): any {
    const user = localStorage.getItem('currentUser');
    if (!user) return null;
    const userObj = JSON.parse(user);
    return userObj
  }

  getInvestorPendingCvvTimeAgo(pending: { requestedAt: string }): string {
    return this.formatCvvRelativePast(pending.requestedAt);
  }

  /** Parses API CVV timestamps (e.g. "YYYY-MM-DD HH:mm:ss") to epoch ms, or null if invalid. */
  private cvvApiTimestampToMs(value: string): number | null {
    if (value == null || value === '') {
      return null;
    }
    const dateStr = String(value).replace(' ', 'T');
    const utcStr = dateStr.indexOf('Z') === -1 && dateStr.indexOf('+') === -1 && dateStr.indexOf('-', 10) === -1
      ? dateStr + 'Z'
      : dateStr;
    const t = new Date(utcStr).getTime();
    return isNaN(t) ? null : t;
  }

  /**
   * Relative time in the past, e.g. "just now", "5 minutes ago", "2 hours 3 minutes ago".
   */
  formatCvvRelativePast(iso: string): string {
    const targetMs = this.cvvApiTimestampToMs(iso);
    if (targetMs == null) {
      return '';
    }
    const now = Date.now();
    const diffMs = Math.max(0, now - targetMs);
    const totalMinutes = Math.floor(diffMs / 60000);
    if (totalMinutes < 1) {
      return 'just now';
    }
    return this.cvvMinutesAndHoursPhrase(diffMs) + ' ago';
  }

  /**
   * Remaining duration until a future instant, e.g. "45 minutes", "2 hours" (no suffix).
   * Empty if the instant is missing or already in the past.
   */
  formatCvvRelativeUntil(iso: string): string {
    const targetMs = this.cvvApiTimestampToMs(iso);
    if (targetMs == null) {
      return '';
    }
    const now = Date.now();
    const diffMs = targetMs - now;
    if (diffMs <= 0) {
      return '';
    }
    const totalMinutes = Math.floor(diffMs / 60000);
    if (totalMinutes < 1) {
      return 'less than a minute';
    }
    return this.cvvMinutesAndHoursPhrase(diffMs);
  }

  private cvvMinutesAndHoursPhrase(diffMs: number): string {
    const totalMinutes = Math.floor(diffMs / 60000);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    if (hours < 1) {
      return totalMinutes + ' minute' + (totalMinutes === 1 ? '' : 's');
    }
    const parts: string[] = [];
    if (hours > 0) {
      parts.push(hours + ' hour' + (hours === 1 ? '' : 's'));
    }
    if (minutes > 0) {
      parts.push(minutes + ' minute' + (minutes === 1 ? '' : 's'));
    }
    return parts.join(' ');
  }

  /** Relative time after authorization, e.g. "24 minutes ago" (for investor CVV success banner). */
  getInvestorAuthorizedCvvTimeAgo(authorizedAt: string): string {
    return this.formatCvvRelativePast(authorizedAt);
  }

  /** e.g. "Feb 23 at 5:30 PM" for authorization_expires_at */
  formatCvvAuthorizationExpiresAt(expiresAt: string): string {
    if (expiresAt == null || expiresAt === '') {
      return '';
    }
    const targetMs = this.cvvApiTimestampToMs(expiresAt);
    if (targetMs == null) {
      return '';
    }
    const dateStr = String(expiresAt).replace(' ', 'T');
    const utcStr = dateStr.indexOf('Z') === -1 && dateStr.indexOf('+') === -1 && dateStr.indexOf('-', 10) === -1
      ? dateStr + 'Z'
      : dateStr;
    const m = moment(utcStr);
    if (!m.isValid()) {
      return '';
    }
    return m.format('MMM D [at] h:mm A');
  }

  copyLinkToClipboard(string: string) {
    let listener = (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', (string));
      e.preventDefault();
    };
    document.addEventListener('copy', listener);
    document.execCommand('copy');
    document.removeEventListener('copy', listener);
  }

}



// WEBPACK FOOTER //
// ./src/app/frontend-services/common.service.ts